import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactGA from "react-ga4";
import { useForm } from "react-hook-form";
import validation from "./validation";
import { Imagesdata } from "../../assets/images/imageData";
import { InputField } from "../../components/InputField/InputField";
import { ErrorMessage } from "@hookform/error-message";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Services from "../../API/services";
import { useLocation } from "react-router-dom";
import { toWords } from 'number-to-words';
import InputComponent from "./InputComponent";
import moment from "moment";
import { onLoading } from "store/slices/loaderSlice";
import {
  CheckPaymentMode,
  daysDiffernce,
  showDate,
  showPercentage,
  showPrice,
  taxOnly,
} from "../../utils/utils";
import { Margin, Resolution, usePDF } from "react-to-pdf";
import {
  getBanquetBookingServices,
  getBanquetBookingVenue,
  getTaxService
} from "API/services/newServices";
import { createLogs } from "../../store/slices/PropertyData";
const MealPlanText = ["EP", "CP", "AP", "MAP"];

const Invoice = () => {
  const [editInvoice, setEditInvoice] = useState(false);
  const { AlertIcon } = Imagesdata || {};
  const { userDetail } = useSelector(authenticationSeletor);
  const { state } = useLocation();
  const [edit, setEdit] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [services, setServices] = useState([]);
  const [venues, setVenues] = useState([]);
  const [paymentMode, setPaymentMode] = useState(state?.paymentMode);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([])
  const [stateList, setStateList] = useState([]);
  const [showBillTo, setShowBillTo] = useState('');
  const [selectState, setSelectState] = useState(0);
  const [allBookingDetails, setAllBookingDetails] = useState({});
  const [xLoading, setXLoading] = useState(false);
  const [tax, setTax] = useState({});


  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const { toPDF, targetRef } = usePDF({
    method: "open",
    filename: "roomInvoice.pdf",
    page: { margin: Margin.NONE, format: "letter" },
    canvas: {
      mimeType: "image/png",
      qualityRatio: 10,
    },
    overrides: {
      pdf: {
        compress: false,
      },
      canvas: {
        useCORS: true,
      },
    },
  });

  const getData = async () => {
    try {
      setXLoading(true)
      const res = await Services.globalService.getSingleBookingDetail(
        state.id
      );
      if (res.status === 200) {
        setAllBookingDetails(res.data.data);
      }
    } catch (error) { }
    finally {
      setXLoading(false)
    }
  };

  useEffect(() => {
    getData();
  }, [])

  const getServices = async (id) => {
    const res = await getBanquetBookingServices(id);
    if (res) setServices(res);
  };

  const getVenueItem = async (id) => {
    const res = await getBanquetBookingVenue(id);
    if (res) setVenues(res);
  };

  const getState = async () => {
    try {
      const state = await Services.globalService.getAllState();
      if (state.status === 200) {
        setStateList(state.data.data);
      }
    } catch (error) { }
  };

  const fetchCities = async () => {
    try {
      const res = await Services.globalService.getCities()
      if (res.status === 200) {
        setCities(res?.data?.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    getState()
    fetchCities()
  }, [])

  useEffect(() => {
    if (state?.banquetData) {
      setValue("addre", state?.address);
      setValue("guestGst", state?.gst);
      setValue("cName", state?.companyName);
      setValue("cAddre", state?.address);
      getServices(state?.banquetBookingId);
      getVenueItem(state?.banquetBookingId);
    }
    setValue("date");
  }, []);

  const getInvoiceDetails = async () => {
    try {
      setLoading(true);
      const res = await Services.property.getInvoiceData(
        `?property_id=${userDetail?.propertyId}`
      );
      if (res.status === 200) {
        setLoading(false);
        if (res?.data?.data?.[0] == null) return;
        setInvoiceData(res?.data?.data[0]);
        if (Object.keys(res?.data?.data[0]).length > 0) {
          setValue("gstIn", res?.data?.data[0]?.gstNumber);
          setValue("gstCode", res?.data?.data[0]?.gstNumber);
          setEdit(true);
        }
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setLoading(false);
    }
  };

  const getTaxApi = async () => {
    try {
      const res = await getTaxService();
      if (res) {
        setTax(res);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getTaxApi();
  }, [])

  const getCategory = async () => {
    if (state?.banquetData) {
      return;
    }
    const res = await Services.property.getRoomCategoryService(
      userDetail?.propertyId
    );
    if (res.status === 200) {
      setCategoryName(
        res.data.data.find((i) => i.id == state.propertyRoomsCategoryId).name
      );
    }
  };

  const editHandler = () => {
    setEditInvoice(true);
    if (edit) {
      setValue("propertyName", invoiceData?.name);
      setValue("mobile", invoiceData?.phone);
      setValue("email", invoiceData?.email);
      setValue("gst", invoiceData?.gstNumber);
      setValue("mobileQuery", invoiceData?.queryContactNumber);
      setValue("address", invoiceData?.address);
      setValue("propertyContent", invoiceData?.content);
    }
  };

  const onSubmit = async ({
    address,
    email,
    gst,
    logo,
    mobile,
    mobileQuery,
    propertyContent,
    propertyName,
  }) => {
    var bodyData = new FormData();
    bodyData.append("property_id", userDetail?.propertyId);
    bodyData.append("logo", logo[0]);
    bodyData.append("name", propertyName);
    bodyData.append("address", address);
    bodyData.append("phone", mobile);
    bodyData.append("email", email);
    bodyData.append("gst_number", gst);
    bodyData.append("content", propertyContent);
    try {
      let res = {};
      let message = "";
      if (edit) {
        res = await Services.property.reEditInvoiceData(
          bodyData,
          invoiceData?.id
        );
        message = "Invoice Details Successfully Updated!";
      } else {
        res = await Services.property.editInvoiceData(bodyData);
        message = "Invoice Details Successfully Submitted!";
      }
      if (res.status === 200) {
        toast.success(message, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        getInvoiceDetails()
        setEditInvoice(false);
      }
      reset();
    } catch (error) { }
  };

  useEffect(() => {
    if (state) {
      getCategory();
    }
    ReactGA.send({ hitType: "pageview", page: "invoice_details" });
    getInvoiceDetails();
    setValue("gstCode", invoiceData?.gstNumber);
    setValue("gstIn", invoiceData?.gstNumber);
  }, []);

  const totalDays = daysDiffernce(
    state?.fromDate,
    state?.toDate
  );

  const givenDate = new Date("2025-09-22");
  const toDates = new Date(state?.toDate)
  const checkTaxPercentage = toDates < givenDate ? 1.12 : (1 + tax?.amount / 100)


  const totalNights = state.fromDate == state.toDate ? 1 : totalDays

  const totalAmount = (state?.bookingAmout)
  const taxableAmount = (totalAmount / checkTaxPercentage)
  const gst = totalAmount - taxableAmount
  const sgst = gst / 2;
  const cgst = gst / 2;
  const roomRate = taxableAmount / (state?.noOfRooms * totalNights)

  let totalCollectedPayment = state?.Payments?.reduce((acc, curr) => acc + Number(curr.paymentAmount), 0)

  const content = invoiceData?.content?.split(".");

  // Voucher Invoice
  const invoicePDF = usePDF({
    method: "open",
    filename: "booking-invoice.pdf",
    page: { margin: Margin.NONE, format: "A4" },
    resolution: 2,
    canvas: { mimeType: "image/png", qualityRatio: 0.7 },
  });

  const printBookingInvoice = async () => {
    dispatch(onLoading(true))
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      await new Promise((resolve) => setTimeout(resolve, 0));
      invoicePDF.toPDF();
    }
    catch { }
    finally {
      dispatch(onLoading(false))
    }
  };

  const allRooms = [];
  for (let key in state) {
    if (
      key.startsWith("room") &&
      state[key] &&
      state[key] !== "null" &&
      state[key] !== "{}"
    ) {
      const roomData = JSON.parse(state[key]);
      const beforeGst = (roomData?.amount / 112 * 100).toFixed(2);
      const gst = (roomData?.amount * (12 / (100 + 12))).toFixed(2)
      allRooms.push({
        room: {
          ...roomData,
          beforeGst: Number(beforeGst),
          gst: gst
        }
      });
    }
  }

  const allExtraCharges = []
  for (let key in state) {
    if (
      key.startsWith("extraCharge") &&
      state[key] &&
      state[key] !== "null" &&
      state[key] !== "{}"
    ) {
      allExtraCharges.push({
        extraCharge: JSON.parse(state[key])
      });
    }
  }

  const otherRoomTotalGst = allRooms?.reduce((acc, curr) => acc + Number(curr.room.gst), 0)
  const otherRoomTotalBegoreGst = allRooms?.reduce((acc, curr) => acc + Number(curr.room.beforeGst), 0)

  const totalSgst = Number(((gst + otherRoomTotalGst) / 2).toFixed(2))
  const totalCgst = Number(((gst + otherRoomTotalGst) / 2).toFixed(2))
  const totalIgst = Number((gst + otherRoomTotalGst).toFixed(2))

  const totalRooms = (allRooms.reduce((acc, curr) => acc + curr.room.room, 0)) + state?.noOfRooms
  const beforeGstAmountForAllRooms = Number((taxableAmount + otherRoomTotalBegoreGst).toFixed())

  const amount = parseFloat(state?.bookingAmout + allExtraCharges?.reduce(
    (sum, extra) => sum + Number(extra?.extraCharge?.price || 0), 0) + allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.amount || 0), 0));
  const words = Number.isFinite(amount)
    ? toWords(amount).replace(/,/g, '')
    : 'Invalid amount';

  const generateInvoiceDate = async () => {
    let payload = {
      id: state?.id,
      invoiceDate: moment(new Date()).format('DD-MM-YYYY')
    }
    const res = await Services.property.invoiceGenrateByDateService(payload)
    if (res.data.status === true) {
      toast.success('Invoice Generated', {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      getData();

      const params = {
        action: `Invoice generated`,
        actionBy: userDetail?.firstName + " " + userDetail?.lastName,
        activityType: "Invoice generated",
        bookingId: state.id,
        paymentMode: null,
        propertyId: userDetail?.propertyId,
        userType: "propertyUser",
      };
      dispatch(createLogs(params));
    }
  }

  return (
    <Layout
      title="Invoice"
      // openHandler={editHandler}
      // buttonTitle="Edit Invoice"
      // extraButton="Download PDF"
      // extraBtnHandler={toPDF}
      withoutContainer
    >
      {
        !xLoading ?
          <>
            <div className={`printBox borders ${allBookingDetails.invoiceDate ? '' : 'preview-watermark'}`} ref={invoicePDF.targetRef} style={{ width: '800px', backgroundColor: '#fff', margin: '0 auto' }}>
              <table className="printInvoice">
                <tbody>
                  <tr>
                    <td colSpan={2} className="text-right">
                      <p style={{ fontWeight: '700' }}>GST : {state?.PropertyMaster?.gstNumber ?? "N/A"}</p>
                      <p style={{ fontWeight: '700' }}>Legal Name : {state?.PropertyMaster?.legalName}</p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="text-center">
                      <h6>{allBookingDetails.invoiceDate ? '' : 'Sample '}Invoice</h6>
                      <h3 style={{ paddingBottom: '0px' }}>{state?.PropertyMaster?.legalName ? state?.PropertyMaster?.legalName : state?.PropertyMaster?.name}</h3>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="text-center">
                      <h4 style={{ fontSize: '18px' }}></h4>
                      <p style={{ paddingTop: '5px', paddingBottom: '5px' }}>{state?.PropertyMaster?.address ?? "Your Property Address"}</p>
                      <p style={{ paddingBottom: '10px' }}>
                        Phone: {state?.PropertyMaster?.propertyMobileNumber ?? "Your Phone Number"},
                        Email: {state?.PropertyMaster?.propertyEmailId ?? "Your Email Address"}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td className="one">
                      <table>
                        <tr>
                          <th>Invoice No</th>
                          <td>: {' '}{state?.bookingCode}
                          </td>
                        </tr>
                        <tr>
                          <th>Guest Name</th>
                          <td>{': '}
                            {state?.User?.name || state?.otherPersonName}
                          </td>
                        </tr>
                        <tr>
                          <th>Bill To</th>
                          <td>{': '}
                            {
                              state?.BillToCompany
                                ? state?.BillToCompany?.companyName
                                : (
                                  state?.source !== "RRooms"
                                    ? state?.otherPersonName
                                    : (state?.User?.company ? state?.User?.company : state?.User?.name)
                                )
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Bill To Address</th>
                          <td> {': '}
                            {
                              state?.BillToCompany
                                ? state?.BillToCompany?.address
                                : (
                                  state?.source !== "RRooms"
                                    ? "--------"
                                    : (state?.User?.address ? state?.User?.address : "--------")
                                )
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>State</th>
                          <td>: {' '}
                            {
                              state?.BillToCompany ? state?.BillToCompany?.state : state?.User?.gst ? state?.User?.state : '--------'
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Bill To GSTIN No</th>
                          <td>: {' '}
                            {
                              state?.BillToCompany ? state?.BillToCompany?.gst : state?.User?.gst ? state?.User?.gst : '--------'
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Source Of Supply</th>
                          <td>: {state?.PropertyMaster?.cityName}</td>
                        </tr>
                      </table>
                    </td>
                    <td className="one">
                      <table>
                        <tr>
                          <th>Date of Invoice</th>
                          <td>: {moment(state?.checkOutDateTime || new Date()).format("DD-MM-YYYY")}</td>
                        </tr>
                        <tr>
                          <th>Room</th>
                          <td>{': '}
                            {(state?.banquetData
                              ? venues?.session
                              : categoryName) ?? "N/A"} /
                            {(state?.banquetData
                              ? venues?.session
                              : state?.assignRoomNo) ?? "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>No of Person</th>
                          <td>
                            : {state?.banquetData
                              ? state?.numberOfGuests ?? "0"
                              : `${state?.adults}`} (A) / 0 (C)
                          </td>
                        </tr>
                        <tr>
                          <th>Rate Type</th>
                          <td>: {MealPlanText[state?.breakFast]}</td>
                        </tr>
                        <tr>
                          <th>No of Nights</th>
                          <td>: {' '}
                            {
                              totalNights

                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Date of Arrival</th>
                          <td>{': '}
                            {moment(
                              state?.fromDate
                                ? state?.fromDate
                                : ''
                            ).format("DD-MM-YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <th>Date of Departure</th>
                          <td> {': '}
                            {moment(
                              state?.toDate
                                ? state?.toDate
                                : ''
                            ).format("DD-MM-YYYY")}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td className="two" colSpan={2}>
                      <table className="invoice-print-alignment">
                        <tr>
                          <th>Sr No</th>
                          <th>Particular</th>
                          <th>HSN/SAC</th>
                          <th>Rooms</th>
                          <th>Rate</th>
                          <th>Total</th>
                          <th>Taxable</th>
                          <th>SGST</th>
                          <th>CGST</th>
                          <th>IGST</th>
                        </tr>
                        <tr>
                          <td>1</td>
                          <td>Room Charges</td>
                          <td>996311</td>
                          <td>
                            {state?.noOfRooms}
                          </td>
                          <td>{Math.round(roomRate)}</td>
                          <td>{state.bookingAmout}</td>
                          <td>{Math.round(taxableAmount)}</td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? 0 : (sgst).toFixed(2)
                            }
                          </td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? 0 : (cgst).toFixed(2)
                            }
                          </td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? Math.round(gst) : 0
                            }
                          </td>
                        </tr>
                        {
                          allRooms?.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 2}</td>
                                <td>Extra Room {i + 1}</td>
                                <td>996311</td>
                                <td>
                                  {'1'}
                                </td>
                                <td>{(item.room?.beforeGst || 0).toFixed(2)}</td>
                                <td>{(item.room?.beforeGst).toFixed(2)}</td>
                                <td>{(item.room?.amount).toFixed(2)}</td>
                                <td>
                                  {
                                    state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName
                                      ? 0 : (Number(item.room?.gst || 0) / 2).toFixed(2)
                                  }
                                </td>
                                <td>
                                  {
                                    state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName
                                      ? 0 : (Number(item.room?.gst || 0) / 2).toFixed(2)
                                  }
                                </td>
                                <td>
                                  {
                                    state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName
                                      ? Math.round(Number(item.room?.gst || 0))
                                      : "0"
                                  }
                                </td>
                              </tr>
                            )
                          })
                        }
                        {
                          allExtraCharges?.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 2}</td>
                                <td>Extra Charge {i + 1} ({item?.extraCharge?.types})</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>{item?.extraCharge?.price}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                              </tr>
                            )
                          })
                        }
                        <tr>
                          <th colspan="2">Total</th>
                          <td></td>
                          <td>{totalRooms}</td>
                          <td>{beforeGstAmountForAllRooms}</td>
                          <td>{state?.bookingAmout + allExtraCharges?.reduce(
                            (sum, extra) => sum + Number(extra?.extraCharge?.price || 0), 0) + allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.amount || 0), 0)}</td>
                          <td>{beforeGstAmountForAllRooms}</td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? 0 : (((sgst || 0) + (allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.gst || 0), 0) / 2)).toFixed(2))
                            }
                          </td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? 0 : (((cgst || 0) + (allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.gst || 0), 0) / 2)).toFixed(2))
                            }
                          </td>
                          <td>
                            {
                              state?.BillToCompany && state?.BillToCompany?.state != state?.PropertyMaster?.stateName ? Math.round(totalIgst) : 0
                            }
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td className="three">
                      <h4>Total Payable Amount</h4>
                      <p style={{ marginBottom: '50px', textTransform: 'capitalize' }}>{words}</p>
                      <table className="invoice-print-alignment">
                        <tr>
                          <th>Payment Date</th>
                          <th>Description</th>
                          <th>Amount</th>
                        </tr>
                        {
                          state?.Payments?.map((item) => {
                            return (
                              <tr key={item?.id}>
                                <td>{new Date(item?.paymentDate).toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                })}</td>
                                <td>{CheckPaymentMode(item?.paymentMode)}</td>
                                <td>{item?.paymentAmount}</td>
                              </tr>
                            )
                          })
                        }
                        <tr>
                          <td colSpan={3} className="text-right"><span>Total</span> {showPrice(totalCollectedPayment)}</td>
                        </tr>
                      </table>
                    </td>
                    <td className="four">
                      <table className="invoice-print-alignment" style={{ marginTop: "-1px" }}>
                        <tr>
                          <th>Total Charges(Rs) :</th>
                          <td>{beforeGstAmountForAllRooms}</td>
                        </tr>
                        <tr>
                          <th>Total Extra Charges(Rs) :</th>
                          <td>{allExtraCharges?.reduce((sum, extra) => sum + Number(extra?.extraCharge?.price || 0), 0)}</td>
                        </tr>
                        <tr>
                          <th>GST(Rs) :</th>
                          <td>{Math.round(((sgst || 0) + (cgst || 0) + (allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.gst || 0), 0))))}</td>
                        </tr>
                        <tr>
                          <th>Total Payable(Rs) :</th>
                          <td>
                            {state?.bookingAmout + allExtraCharges?.reduce(
                              (sum, extra) => sum + Number(extra?.extraCharge?.price || 0), 0) + allRooms?.reduce((sum, extraRoom) => sum + Number(extraRoom?.room?.amount || 0), 0)}
                          </td>
                        </tr>
                        <tr>
                          <th>Total Payment(Rs) :</th>
                          <td>
                            {showPrice(totalCollectedPayment)}
                          </td>
                        </tr>
                        <tr>
                          <th>Balance(Rs) :</th>
                          <td>{showPrice(state?.dueAmount)}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <div style={{ fontWeight: '600', marginTop: '5px', marginBottom: '0px' }}>Remark :</div>
                      <ul style={{ fontSize: '10px', marginBottom: '15px' }}>
                        <li style={{ fontSize: '10px' }}>Check Out Time 11:00 AM</li>
                        <li style={{ fontSize: '10px' }}>All Disputes subject to {state?.PropertyMaster?.cityName} Jurisdiction.</li>
                        <li style={{ fontSize: '10px' }}>I agree that I am liable for the full payment of this bill in the event it is not paid by Company/Organization or Person indicated.</li>
                        <li style={{ fontSize: '10px' }}>I have collected my Luggage/Ariticies/Belonging at the time of Check out any suggestion/query then contact</li>
                        <li style={{ fontSize: '10px' }}>Please keep your keys at reception while leaving the hotel.</li>
                        <li style={{ fontSize: '10px' }}>Feel free to reception for any service.</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="five" style={{ borderTop: 'solid 1px #000', paddingTop: '0px', paddingBottom: '5px' }}>
                      <table>
                        <tr>
                          <th>This Folio is in</th>
                          <td>: {state?.bookingCode}</td>
                        </tr>
                        <tr>
                          <th>Reception (C/I)</th>
                          <td>: {userDetail?.name}</td>
                        </tr>
                        <tr>
                          <th>Cashier (C/O)</th>
                          <td>: {userDetail?.name}</td>
                        </tr>
                        <tr>
                          <th>Date</th>
                          <td>: {
                            state?.checkOutDateTime
                              ? moment(state?.checkOutDateTime).format(
                                "DD-MM-YYYY, HH:MM"
                              )
                              : "Yet to Check-Out"
                          }</td>
                        </tr>
                        <tr>
                          <th>Page</th>
                          <td>: Page 1 of 1</td>
                        </tr>
                      </table>
                    </td>
                    <td style={{ borderTop: 'solid 1px #000', paddingTop: '12px' }}>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-center" style={{ fontSize: '14px', borderTop: 'solid 1px #000', paddingTop: '10px' }}>
                      (Guest Signature)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-center mt-3">
              {
                !allBookingDetails?.invoiceDate &&
                <button type="button" className="btn btn-secondary btn-sm" onClick={generateInvoiceDate}>Generate Invoice</button>
              }
              {
                allBookingDetails?.invoiceDate &&
                <button type="button" className="btn btn-primary btn-sm" onClick={printBookingInvoice}>Print</button>
              }
            </div>
          </> : <div className="printBox borders" style={{ width: '800px', minHeight: '900px', margin: '0 auto' }}></div>
      }
      <Modal
        backdrop="static"
        show={editInvoice}
        onHide={() => {
          setEditInvoice(false);
          reset();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Container>
              <Row>
                <h6 className="text-dark">Invoice Header :</h6>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="propertyName"
                    text="Property Name"
                    type="text"
                    placeholder="Enter Property Name"
                    field={"propertyName"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.propertyName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage
                          errors={errors}
                          notnull
                          name={"propertyName"}
                        />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="mobile"
                    text="Property Mobile Number"
                    type="text"
                    max={10}
                    placeholder="Enter Property Mobile Number"
                    field={"mobile"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.mobile?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"mobile"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="email"
                    text="Property Email ID"
                    type="text"
                    placeholder="Enter Property Email ID"
                    field={"email"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.email?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"email"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="gst"
                    text="Property GST Number"
                    type="text"
                    placeholder="Enter Property GST Number"
                    field={"gst"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.gst?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"gst"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="logo"
                    text="Property Logo"
                    type="file"
                    placeholder="Enter Property Logo"
                    field={"logo"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="address"
                    text="Property Address"
                    type="textArea"
                    placeholder="Enter Property Address"
                    field={"address"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.address?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>{errors?.address?.message}</span>
                    </div>
                  )}
                </Col>
                <Row className="justify-content-center">
                  <Col xs={1}>
                    <Button type="submit">Submit</Button>
                  </Col>
                </Row>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Invoice;
